import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { Col, Form, Modal, Row, Table, Offcanvas } from "react-bootstrap";
import downArrow from "../../Assets/Images/Header/downArrow.svg";
import moment from "moment";
import closeBtn from "../../Assets/Images/Action Icons/closeIcon.svg";
import questionblue from "../../Assets/Images/question-blue.svg";
import { commonService } from "../../utils/commonService";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import ProposedRateModal from "./Modal/ProposedRateModal";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const PriceSimulatorDetailAnalysis = ({
    closeModal,
    data,
    show
}) => {

    const [IsFirstTimeValue, setIsFirstTimeValue] = useState(false);
    const [showPaceModal, setShowPaceModal] = useState(false);
    const [DisplayLoading, setDisplayLoading] = useState(false);
    const [ChartLoading, setChartLoading] = useState(false);
    const [rateModalDetails, setRateModalDetails] = useState([]);
    const [SimulatorRateDetails, setSimulatorRateDetails] = useState([]);
    const [chartConfig, setChartConfig] = useState(null);
    /*const [PredictedData, setPredictedData] = useState({ PredictedRate: 0, clicked_date: new Date(), PredictedRateMin: 0, PredictedRateMax: 100 });*/
    const [PredictedData, setPredictedData] = useState(null);
    const [TxtPredictedRate, setTxtPredictedRate] = useState(0);
    const [PredictedRate, setPredictedRate] = useState(0);

    const [SimulatorRateOriginalDetails, setSimulatorRateOriginalDetails] = useState([]);


    const getProposedRateDetails = async () => {
        let rateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICING_SIMULATOR_RATE.SINGLE_DAY_RECOMMENDATION,
                body: {
                    propertycode: data?.propertyCode,
                    asofdate: data?.asOfDate,
                    startdate: commonService.getDateInDBFormat(data?.selectedItem?.dates),
                    enddate: commonService.getDateInDBFormat(data?.selectedItem?.dates),
                },
            },
            false
        );

        let response = apiResponse(false, rateResponse);

        if (response?.isValidate) {
            setRateModalDetails(response?.data?.data)
        }

        if (!response?.isValidate) {
            setRateModalDetails([])
        }
    };

    const getSimulatorRateDetails = async () => {
        let prev_asofdate = new Date(data.asOfDate);
        prev_asofdate = new Date(prev_asofdate.setDate(prev_asofdate.getDate() - 7));

        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICING_SIMULATOR_RATE.PRICING_SIMULATOR_RESULT,
                body: {
                    propertycode: data.propertyCode,
                    asofdate: data.asOfDate,
                    predictedrate: PredictedData.PredictedRate ? parseInt(PredictedData.PredictedRate) : 0,
                    clicked_date: PredictedData.clicked_date,
                    prev_asofdate: commonService.getDateInDBFormat(prev_asofdate)
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            if (IsFirstTimeValue) {
                setSimulatorRateOriginalDetails(response?.data?.data)
            }
            setSimulatorRateDetails(response?.data?.data)
        }

        if (!response?.isValidate) {
            setSimulatorRateDetails([])
        }
        setIsFirstTimeValue(false);
        setDisplayLoading(false);
    };

    const getRateAndBookingPace = async () => {
        let prev_asofdate = new Date(data.asOfDate);
        prev_asofdate = new Date(prev_asofdate.setDate(prev_asofdate.getDate() - 7));

        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICING_SIMULATOR_RATE.DBD_PRICING_CURVE,
                body: {
                    "propertycode": data.propertyCode,
                    "startasofdate": commonService.getDateInDBFormat(prev_asofdate),
                    "endasofdate": commonService.getDateInDBFormat(data.asOfDate),
                    "startdate": commonService.getDateInDBFormat(data.selectedItem.dates),
                    "enddate": commonService.getDateInDBFormat(data.selectedItem.dates)
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);
        if (response?.isValidate) {
            const rawData = response?.data?.data;
            if (rawData && rawData.length > 0) {
                const getDr = (stay, asof) => Math.ceil((new Date(stay) - new Date(asof)) / 86400000);

                const lastObj = rawData[rawData.length - 1];
                const today_dr = getDr(lastObj.staydate, lastObj.asofdate);

                let max_dr = 0;
                rawData.forEach(d => {
                    const dr = getDr(d.staydate, d.asofdate);
                    if (dr > max_dr) max_dr = dr;
                });

                const labels = [];
                for (let i = max_dr; i >= 0; i--) {
                    labels.push(i);
                }

                const actualsMap = {};
                rawData.forEach(d => {
                    const dr = getDr(d.staydate, d.asofdate);
                    actualsMap[dr] = d;
                });

                const forecastMap = {};
                (lastObj.pricing_curve || []).forEach(c => {
                    forecastMap[c.days_remaining] = c;
                });

                const otbActual = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].rms) : null);
                const otbForecast = labels.map(dr => dr <= today_dr && forecastMap[dr] ? parseFloat(forecastMap[dr].dba) : null);
                const todayActualRms = actualsMap[today_dr] ? parseFloat(actualsMap[today_dr].rms) : null;
                const otbForecastConnected = otbForecast.map((val, idx) => labels[idx] === today_dr ? todayActualRms : val);

                const actualTodayRec = actualsMap[today_dr] ? parseFloat(actualsMap[today_dr].recommended_rate) : null;
                const curveTodayRec = forecastMap[today_dr] ? parseFloat(forecastMap[today_dr].rate !== undefined ? forecastMap[today_dr].rate : forecastMap[today_dr].recommended_rate) : null;
                const shift = (actualTodayRec !== null && curveTodayRec !== null && !isNaN(actualTodayRec) && !isNaN(curveTodayRec)) ? (actualTodayRec - curveTodayRec) : 0;

                const recRateActual = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].recommended_rate) : null);
                const recRateForecast = labels.map(dr => dr <= today_dr && forecastMap[dr] ? Math.round(parseFloat(forecastMap[dr].rate !== undefined ? forecastMap[dr].rate : forecastMap[dr].recommended_rate) + shift) : null);
                const todayActualRec = actualsMap[today_dr] ? parseFloat(actualsMap[today_dr].recommended_rate) : null;
                const recRateForecastConnected = recRateForecast.map((val, idx) => labels[idx] === today_dr ? todayActualRec : val);

                const adrData = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].adr) : null);
                const todayBar = actualsMap[today_dr] ? parseFloat(actualsMap[today_dr].current_bar) : (data?.selectedItem?.current_bar ? parseFloat(data.selectedItem.current_bar) : null);
                const currentBarData = labels.map(dr => dr >= today_dr ? todayBar : null);
                const compSetHighData = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].compset_high) : null);
                const compSetAvgData = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].compset_avg) : null);
                const compSetLowData = labels.map(dr => dr >= today_dr && actualsMap[dr] ? parseFloat(actualsMap[dr].compset_low) : null);

                setChartConfig({
                    data: {
                        labels,
                        datasets: [
                            { label: "OTB (actual)", data: otbActual, borderColor: "#3b82f6", backgroundColor: "#3b82f6", yAxisID: "y-rooms", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#3b82f6", tension: 0.4 },
                            { label: "OTB", data: otbForecastConnected, borderColor: "#93c5fd", backgroundColor: "#93c5fd", borderDash: [5, 5], yAxisID: "y-rooms", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#93c5fd", tension: 0.4 },
                            { label: "RecRate", data: recRateActual, borderColor: "#ef4444", backgroundColor: "#ef4444", yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#ef4444", tension: 0.4 },
                            { label: "RecRate", data: recRateForecastConnected, borderColor: "#f59e0b", backgroundColor: "#f59e0b", borderDash: [5, 5], yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#f59e0b", tension: 0.4 },
                            { label: "ADR", data: adrData, borderColor: "#10b981", backgroundColor: "#10b981", borderDash: [5, 5], yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#10b981", tension: 0.4 },
                            { label: "Current BAR", data: currentBarData, borderColor: "#8b5cf6", backgroundColor: "#8b5cf6", borderDash: [5, 5], yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#8b5cf6", tension: 0 },
                            { label: "CompSet High", data: compSetHighData, borderColor: "#bfdbfe", backgroundColor: "#bfdbfe", yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#bfdbfe", tension: 0.4 },
                            { label: "CompSet Avg", data: compSetAvgData, borderColor: "#60a5fa", backgroundColor: "#60a5fa", yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#60a5fa", tension: 0.4 },
                            { label: "CompSet Low", data: compSetLowData, borderColor: "#1d4ed8", backgroundColor: "#1d4ed8", yAxisID: "y-rate", pointRadius: 0, pointHoverRadius: 6, pointHoverBackgroundColor: "#fff", pointHoverBorderWidth: 2, pointHoverBorderColor: "#1d4ed8", tension: 0.4 }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        interaction: { mode: 'index', intersect: false },
                        plugins: {
                            legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'rect' } },
                            tooltip: {
                                backgroundColor: 'rgba(23, 31, 46, 0.9)',
                                titleColor: '#fff',
                                bodyColor: '#fff',
                                padding: 10,
                                usePointStyle: true,
                                callbacks: {
                                    title: (context) => {
                                        const day = context[0].label;
                                        if (parseInt(day) < today_dr) {
                                            return `Days remaining: ${day} - forecast`;
                                        } else {
                                            const stayd = new Date(lastObj.staydate);
                                            stayd.setDate(stayd.getDate() - parseInt(day));
                                            const dateStr = stayd.toISOString().split('T')[0];
                                            return `Days remaining: ${day} - ${dateStr}`;
                                        }
                                    }
                                }
                            }
                        },
                        scales: {
                            x: { title: { display: true, text: 'Days Remaining' }, grid: { display: false } },
                            'y-rate': { type: 'linear', display: true, position: 'left', title: { display: true, text: 'Rate' }, grid: { drawOnChartArea: true, color: '#f3f3f3' } },
                            'y-rooms': { type: 'linear', display: true, position: 'right', title: { display: true, text: 'Rooms', color: '#3366cc' }, grid: { drawOnChartArea: false }, ticks: { color: '#3366cc' } }
                        }
                    },
                    plugins: [{
                        id: 'todayLine',
                        afterDraw: (chart) => {
                            const datasetMeta = chart.getDatasetMeta(0);
                            let xCoord = null;
                            chart.data.labels.forEach((label, index) => {
                                if (label == today_dr) {
                                    xCoord = datasetMeta.data[index]?.x;
                                }
                            });

                            if (xCoord !== null && xCoord !== undefined) {
                                const ctx = chart.ctx;
                                ctx.save();
                                ctx.beginPath();
                                ctx.moveTo(xCoord, chart.chartArea.top);
                                ctx.lineTo(xCoord, chart.chartArea.bottom);
                                ctx.lineWidth = 1;
                                ctx.strokeStyle = '#cccccc';
                                ctx.setLineDash([5, 5]);
                                ctx.stroke();

                                ctx.fillStyle = '#666666';
                                if (xCoord > chart.chartArea.right - 50) {
                                    ctx.textAlign = 'right';
                                } else {
                                    ctx.textAlign = 'center';
                                }
                                ctx.fillText('AsofDate (today)', xCoord, chart.chartArea.top - 5);
                                ctx.restore();
                            }
                        }
                    }]
                });
            } else {
                setChartConfig(null);
            }
        }

        if (!response?.isValidate) {
            setChartConfig(null);
        }
        setChartLoading(false);
    };

    useEffect(() => {
        setIsFirstTimeValue(true);
        setDisplayLoading(true);
        setChartLoading(true);

        let PredictedRateMin = 0;
        let PredictedRateMax = 100;

        if (data.selectedItem.compset_avg && parseInt(data.selectedItem.compset_avg)) {
            PredictedRateMax = parseInt(data.selectedItem.compset_avg);
        }


        if (parseInt(data.selectedItem.optimal_bar)) {
            let diff = parseInt(parseInt(data.selectedItem.optimal_bar) * 50 / 100);

            PredictedRateMin = parseInt(parseInt(data.selectedItem.optimal_bar) - diff);
            if (PredictedRateMin < 0) {
                PredictedRateMin = 0;
            }
            PredictedRateMax = parseInt(parseInt(data.selectedItem.optimal_bar) + diff);
        }


        setPredictedData({ PredictedRate: data.selectedItem.optimal_bar, clicked_date: data.selectedItem.dates, PredictedRateMin: PredictedRateMin, PredictedRateMax: PredictedRateMax });
        setTxtPredictedRate(data.selectedItem.optimal_bar ? parseInt(data.selectedItem.optimal_bar) : 0);
        setPredictedRate(data.selectedItem.optimal_bar ? parseInt(data.selectedItem.optimal_bar) : 0)

    }, [data]);

    const fetchData = async () => {
        getProposedRateDetails();
        getSimulatorRateDetails();
        getRateAndBookingPace();
    }

    useEffect(() => {
        if (PredictedData) {
            fetchData();
        }
    }, [PredictedData]);


    function fnCompareOriginalDetails(keyname) {
        let className = "fw-bold";
        if (SimulatorRateDetails && SimulatorRateOriginalDetails) {
            if (SimulatorRateDetails.length > 0 && SimulatorRateOriginalDetails.length > 0) {

                if (keyname === "variance_roomsold") {
                    if (SimulatorRateDetails?.[0]?.["current_room_sold"] && SimulatorRateOriginalDetails?.[0]?.["current_room_sold"] && SimulatorRateDetails?.[0]?.["proposed_roomsold"] && SimulatorRateOriginalDetails?.[0]?.["proposed_roomsold"]) {

                        let SimulatorRateDetailsvariance_roomsold = (SimulatorRateDetails?.[0]?.current_room_sold ? SimulatorRateDetails?.[0]?.current_room_sold : 0) - (SimulatorRateDetails?.[0]?.proposed_roomsold ? SimulatorRateDetails?.[0]?.proposed_roomsold : 0);


                        let SimulatorRateOriginalDetailsvariance_roomsold = (SimulatorRateOriginalDetails?.[0]?.current_room_sold ? SimulatorRateOriginalDetails?.[0]?.current_room_sold : 0) - (SimulatorRateOriginalDetails?.[0]?.proposed_roomsold ? SimulatorRateOriginalDetails?.[0]?.proposed_roomsold : 0);


                        if (parseFloat(SimulatorRateOriginalDetailsvariance_roomsold) > parseFloat(SimulatorRateDetailsvariance_roomsold)) {
                            className = "fw-bold redText";
                        }
                        else if (parseFloat(SimulatorRateOriginalDetailsvariance_roomsold) < parseFloat(SimulatorRateDetailsvariance_roomsold)) {
                            className = "fw-bold greenText";
                        }
                    }
                }
                else {
                    if (SimulatorRateDetails?.[0]?.[keyname] && SimulatorRateOriginalDetails?.[0]?.[keyname]) {
                        if (parseFloat(SimulatorRateOriginalDetails?.[0]?.[keyname]) > parseFloat(SimulatorRateDetails?.[0]?.[keyname])) {
                            className = "fw-bold redText";
                        }
                        else if (parseFloat(SimulatorRateOriginalDetails?.[0]?.[keyname]) < parseFloat(SimulatorRateDetails?.[0]?.[keyname])) {
                            className = "fw-bold greenText";
                        }
                    }
                }
            }
        }
        return className;
    }

    function fnGetStatusColor(verdict) {
        let color = "neutral";
        if (verdict) {
            if (verdict.toLowerCase() === "favorable") {
                color = "#1c6b1c";
            }
            else if (verdict.toLowerCase() === "nochange") {
                color = "#fba301";
            }
            else if (verdict.toLowerCase() === "neutral") {
                color = "#090808";
            }
            else if (verdict.toLowerCase() === "unfavorable") {
                color = "#ff0101";
            }
        }
        return color;
    }



    const [RMCopilotData, setRMCopilotData] = useState({
        IsShowRMCopilot: false,
        IsLoading: false,
        Data: ""
    });


    const CallRMCopilot = async () => {
        setRMCopilotData({
            IsShowRMCopilot: true,
            IsLoading: true,
            Data: ""
        })

        let prev_asofdate = new Date(data.asOfDate);
        prev_asofdate = new Date(prev_asofdate.setDate(prev_asofdate.getDate() - 1));


        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICING_SIMULATOR_RATE.WHAT_IF_SIMULATOR_ASSISTANT,
                body: {
                    asofdate: data.asOfDate,
                    startdate: PredictedData.clicked_date,
                    enddate: PredictedData.clicked_date,
                    propertycode: data.propertyCode,
                    clicked_date: PredictedData.clicked_date,
                    prev_asofdate: commonService.getDateInDBFormat(prev_asofdate),
                    predictedrate: PredictedData.PredictedRate ? parseInt(PredictedData.PredictedRate) : 0,
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {

            setRMCopilotData({
                IsShowRMCopilot: true,
                IsLoading: false,
                Data: response?.data?.data?.message
            })
        }
        else {
            setRMCopilotData({
                IsShowRMCopilot: true,
                IsLoading: false,
                Data: ""
            })
        }
    }

    return (
        <div className="insightOffcanvasWrapper">
            <Offcanvas
                show={show}
                onHide={closeModal}
                placement="end"
                className="insightOffcanvasWrapper pricing-simulator-details"
            >
                <Offcanvas.Header closeButton className="">
                    <Offcanvas.Title>
                        {
                            DisplayLoading ?
                                <></>
                                : <>
                                    Date : {commonService.getDateInFormat(SimulatorRateDetails?.[0]?.selected_date)} {SimulatorRateDetails?.[0]?.dayofweek} ({commonService.formateAmount(PredictedRate)}) ({SimulatorRateDetails?.[0]?.total_rooms} Rooms)
                                </>
                        }
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {DisplayLoading ? (
                        <Loader />
                    ) : (
                        SimulatorRateDetails && SimulatorRateDetails.length > 0 &&
                        <div className="PriceSimulatorDetailAnalysis-container mt-2">
                            <h3>Input Parameters</h3>
                            <div className="PriceSimulatorDetailAnalysis-card grid background">
                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>Current BAR</label><br />
                                    <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-teal">{commonService.formateAmount(SimulatorRateDetails?.[0]?.current_bar ? SimulatorRateDetails?.[0]?.current_bar : 0)}</div>
                                </div>

                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>Current OTB</label><br />
                                    <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-teal">{SimulatorRateDetails?.[0]?.current_otb ? SimulatorRateDetails?.[0]?.current_otb : 0}</div>
                                </div>

                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>Current Revenue</label><br />
                                    <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-teal">{commonService.formateAmount(SimulatorRateDetails?.[0]?.current_revenue ? SimulatorRateDetails?.[0]?.current_revenue : 0)}</div>
                                </div>


                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>Forecasted Occ (%)</label><br />
                                    <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-blue">{SimulatorRateDetails?.[0]?.forecast_occupancy}%</div>
                                </div>
                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    {/* <label>Demand Score (0-1)</label><br /> */}
                                    <label>Demand Score</label><br />
                                    {/* <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-green">{parseFloat(SimulatorRateDetails?.[0]?.demand_score)?.toFixed(2)}</div> */}
                                    <div className="PriceSimulatorDetailAnalysis-badge PriceSimulatorDetailAnalysis-green">{parseInt(SimulatorRateDetails?.[0]?.demand_score)}</div>
                                </div>
                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>CompSet Avg Rate</label>
                                    <div className="PriceSimulatorDetailAnalysis-value">{commonService.formateAmount(SimulatorRateDetails?.[0]?.compset_avg_rate ? SimulatorRateDetails?.[0]?.compset_avg_rate : 0)}</div>
                                </div>
                                <div className="PriceSimulatorDetailAnalysis-card-data">
                                    <label>Days to Arrival</label>
                                    <div className="PriceSimulatorDetailAnalysis-value">{SimulatorRateDetails?.[0]?.days_to_arrival}</div>
                                </div>

                                <div className="PriceSimulatorDetailAnalysis-card-data" title={SimulatorRateDetails?.[0]?.season}>
                                    <label>Season</label>
                                    <div className="PriceSimulatorDetailAnalysis-value">{SimulatorRateDetails?.[0]?.season && SimulatorRateDetails?.[0]?.season.length > 25 ? SimulatorRateDetails?.[0]?.season.substr(0, 24) : SimulatorRateDetails?.[0]?.season}</div>
                                </div>
                            </div>
                            <div className="PriceSimulatorDetailAnalysis-card">
                                <div className="range-custome-ui">
                                    <div className="range-custome-ui-header">
                                        <label className="proposed-rate-lable">Proposed Rate</label>
                                        <span className="ms-2 cursor-pointer" title="Why this rate ?" onClick={() => setShowPaceModal(true)}>
                                            <img src={questionblue} alt="questionblue" />
                                        </span>
                                        <label className="proposed-rate-value">{commonService.formateAmount(TxtPredictedRate)}</label>
                                    </div>
                                    <Form.Range id={commonService.generateGlobalClickTrackerID("PriceSimulatorDetailAnalysis", "form-range-onchange", data)}
                                        className="dynamic-range"
                                        style={{ "--range-color": fnGetStatusColor(SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : "") }}
                                        min={PredictedData.PredictedRateMin}
                                        max={PredictedData.PredictedRateMax}
                                        step={1}
                                        value={TxtPredictedRate}
                                        onChange={(e) =>
                                            setTxtPredictedRate(e.target.value)
                                        }
                                        onMouseUp={(e) => setPredictedData(prev => ({
                                            ...prev,
                                            PredictedRate: e.target.value ? parseInt(e.target.value) : 0
                                        }))}
                                    />
                                    <div className="range-custome-ui-range">
                                        <label className="proposed-rate-min">{commonService.formateAmount(PredictedData.PredictedRateMin)}</label>
                                        <label className="proposed-rate-max">{commonService.formateAmount(PredictedData.PredictedRateMax)}</label>
                                    </div>
                                </div>

                                <table className="CalculationAndPlan">
                                    <tr>
                                        <td className="Calculation">
                                            <h3>Step-By-Step Calculation</h3>
                                            <div className="ViewPropertySetupTable mainTableClass">
                                                <div className="stripped__table">
                                                    <div className="table-responsive tblDynamicPickupSticky">
                                                        <Table className="table-with-spacing positionStaticTable dailySummaryTbl">
                                                            <tbody>
                                                                <tr>
                                                                    <td>Rate Change % :</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.rate_change_perc ? parseFloat(SimulatorRateDetails?.[0]?.rate_change_perc) < 0 ? "greenText" : "redText" : ""}`}>{SimulatorRateDetails?.[0]?.rate_change_perc}%</td>
                                                                </tr>
                                                                <tr>

                                                                    <td>Effective PED :</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}Text`}>{SimulatorRateDetails?.[0]?.effective_ped}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Base PED (Wed, Shoulder) :</td>
                                                                    <td className="text-end ">{SimulatorRateDetails?.[0]?.base_ped}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Predicted Occ Change % :</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}Text`}>{SimulatorRateDetails?.[0]?.predicted_occ_change}%</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Rate Index : </td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}Text`}>{SimulatorRateDetails?.[0]?.rate_index}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Proposed Occ % :</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}Text`}>{SimulatorRateDetails?.[0]?.proposed_occupancy}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>CompSet Factor :</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}Text`}>{SimulatorRateDetails?.[0]?.compset_factor}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Demand Factor :</td>
                                                                    <td className="text-end ">{SimulatorRateDetails?.[0]?.demand_factor}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Segment Mix Factor :</td>
                                                                    <td className="text-end ">{SimulatorRateDetails?.[0]?.segment_mix_factor}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Lead Time Factor :</td>
                                                                    <td className="text-end ">{SimulatorRateDetails?.[0]?.lead_time_factor}</td>
                                                                </tr>
                                                            </tbody>

                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>


                                        </td>
                                        <td className="Plan">
                                            <h3>Current Plan Vs Proposed Plan</h3>
                                            <div className="ViewPropertySetupTable mainTableClass">
                                                <div className="stripped__table">
                                                    <div className="table-responsive tblDynamicPickupSticky">
                                                        <Table className="table-with-spacing positionStaticTable dailySummaryTbl">
                                                            <thead>
                                                                <tr>
                                                                    <th>METRIC</th>
                                                                    <th className="text-end">CURRENT PLAN</th>
                                                                    <th className="text-end">PROPOSED PLAN</th>
                                                                    <th className="text-end">VARIANCE</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Rate (BAR / ADR)</td>
                                                                    <td className="text-end">{commonService.formateAmount(SimulatorRateDetails?.[0]?.current_bar ? SimulatorRateDetails?.[0]?.current_bar : 0)}</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_rate")}`}>{commonService.formateAmount(SimulatorRateDetails?.[0]?.proposed_rate ? SimulatorRateDetails?.[0]?.proposed_rate : 0)}</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.variance_rate ? parseFloat(SimulatorRateDetails?.[0]?.variance_rate) < 0 ? "redText" : "greenText" : ""}`}>{commonService.formateAmount(SimulatorRateDetails?.[0]?.variance_rate ? SimulatorRateDetails?.[0]?.variance_rate : 0)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Forecasted Occupancy</td>
                                                                    <td className="text-end">{SimulatorRateDetails?.[0]?.forecast_occupancy}%</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_occupancy")}`}>{SimulatorRateDetails?.[0]?.proposed_occupancy}%</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.variance_forecasted_occ ? parseFloat(SimulatorRateDetails?.[0]?.variance_forecasted_occ) < 0 ? "redText" : "greenText" : ""}`}>{SimulatorRateDetails?.[0]?.variance_forecasted_occ}%</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>RevPAR</td>
                                                                    <td className="text-end">{commonService.formateAmount(SimulatorRateDetails?.[0]?.current_revpar ? SimulatorRateDetails?.[0]?.current_revpar : 0)}</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_revpar")}`}>{commonService.formateAmount(SimulatorRateDetails?.[0]?.proposed_revpar ? SimulatorRateDetails?.[0]?.proposed_revpar : 0)}</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.variance_revpar ? parseFloat(SimulatorRateDetails?.[0]?.variance_revpar) < 0 ? "redText" : "greenText" : ""}`}>{commonService.formateAmount(SimulatorRateDetails?.[0]?.variance_revpar ? SimulatorRateDetails?.[0]?.variance_revpar : 0)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Room Revenue (Daily)</td>
                                                                    <td className="text-end">{commonService.formateAmount(SimulatorRateDetails?.[0]?.current_room_revenue ? SimulatorRateDetails?.[0]?.current_room_revenue : 0)}</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_room_revenue")}`}>{commonService.formateAmount(SimulatorRateDetails?.[0]?.proposed_room_revenue ? SimulatorRateDetails?.[0]?.proposed_room_revenue : 0)}</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.variance_room_revenue ? parseFloat(SimulatorRateDetails?.[0]?.variance_room_revenue) < 0 ? "redText" : "greenText" : ""}`}>
                                                                        {commonService.formateAmount(SimulatorRateDetails?.[0]?.variance_room_revenue ? SimulatorRateDetails?.[0]?.variance_room_revenue : 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Rooms Sold</td>
                                                                    <td className="text-end">{SimulatorRateDetails?.[0]?.current_room_sold ? SimulatorRateDetails?.[0]?.current_room_sold : 0}</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_roomsold")}`}>{SimulatorRateDetails?.[0]?.proposed_roomsold ? SimulatorRateDetails?.[0]?.proposed_roomsold : 0}</td>

                                                                    <td className={`text-end fw-bold ${(SimulatorRateDetails?.[0]?.proposed_roomsold ? SimulatorRateDetails?.[0]?.proposed_roomsold : 0) - (SimulatorRateDetails?.[0]?.current_room_sold ? SimulatorRateDetails?.[0]?.current_room_sold : 0) < 0 ? "redText" : "greenText"}`}>
                                                                        {(SimulatorRateDetails?.[0]?.proposed_roomsold ? SimulatorRateDetails?.[0]?.proposed_roomsold : 0) - (SimulatorRateDetails?.[0]?.current_room_sold ? SimulatorRateDetails?.[0]?.current_room_sold : 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>CompSet Index</td>
                                                                    <td className="text-end">{(SimulatorRateDetails?.[0]?.current_compset_index ? SimulatorRateDetails?.[0]?.current_compset_index : 0)}</td>
                                                                    <td className={`text-end ${fnCompareOriginalDetails("proposed_compset_index")}`}>{(SimulatorRateDetails?.[0]?.proposed_compset_index ? SimulatorRateDetails?.[0]?.proposed_compset_index : 0)}</td>
                                                                    <td className={`text-end fw-bold ${SimulatorRateDetails?.[0]?.variance_compset_index ? parseFloat(SimulatorRateDetails?.[0]?.variance_compset_index) < 0 ? "redText" : "greenText" : ""}`}>{(SimulatorRateDetails?.[0]?.variance_compset_index ? SimulatorRateDetails?.[0]?.variance_compset_index : 0)}</td>
                                                                </tr>
                                                            </tbody>

                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                </table>
                                <div className={`PriceSimulatorDetailAnalysis-verdict bgcolor ${SimulatorRateDetails?.[0]?.verdict ? (SimulatorRateDetails?.[0]?.verdict.replace(" ", "")).toLowerCase() : " "}`} >
                                    {SimulatorRateDetails?.[0]?.revenue_impact_verdict}
                                    <button id={commonService.generateGlobalClickTrackerID("PriceSimulatorDetailAnalysis", "ask-rm-copilot", data)} className="default-btn" onClick={(e) => CallRMCopilot()}>
                                        Ask RM Copilot
                                    </button>
                                </div>

                            </div>
                            {/* <div className="PriceSimulatorDetailAnalysis-card">
                                <h3>Segment Mix</h3>
                                <div className="ViewPropertySetupTable mainTableClass">
                                    <div className="stripped__table">
                                        <div className="table-responsive tblDynamicPickupSticky">
                                            <Table className="table-with-spacing positionStaticTable dailySummaryTbl">
                                                <thead>
                                                    <tr>
                                                        <th>SEGMENT</th>
                                                        <th className="text-center">MIX %</th>
                                                        <th className="text-center">SEGMENT PED</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        SimulatorRateDetails.map((sg) => {
                                                            return <tr>
                                                                <td>{sg.market_segment}</td>
                                                                <td className="text-center">{sg.segment_occ}%</td>
                                                                <td className="text-center">{sg.segment_ped ? parseFloat(sg.segment_ped).toFixed(2) : 0}</td>
                                                            </tr>
                                                        })
                                                    }
                                                    <tr>
                                                        <td><b>Weighted Segment PED</b></td>
                                                        <td className="text-center"></td>
                                                        <td className="text-center"><b>{SimulatorRateDetails?.[0]?.weighted_segment_ped}</b></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="PriceSimulatorDetailAnalysis-card mt-3">
                                <h3>Rate &amp; Booking Pace</h3>
                                {ChartLoading ? (
                                    <div className="d-flex justify-content-center p-5"><Loader /></div>
                                ) : chartConfig ? (
                                    <div className="mt-3" style={{ height: '400px', width: '100%' }}>
                                        <Line
                                            data={chartConfig?.data}
                                            options={chartConfig?.options}
                                            plugins={chartConfig?.plugins}
                                        />
                                    </div>
                                ) : (
                                    <div className="PriceSimulatorDetailAnalysis-noChart align-items-center justify-content-center d-flex">No Chart Data Available</div>
                                )}
                            </div>
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>

            {
                RMCopilotData.IsShowRMCopilot &&
                <Modal
                    className="DeviceDetailModalMain"
                    centered
                    size="lg"
                    show={RMCopilotData.IsShowRMCopilot}
                    onHide={(e) => setRMCopilotData({
                        IsShowRMCopilot: false,
                        IsLoading: false,
                        Data: ""
                    })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Summary</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {RMCopilotData.IsLoading ? (
                            <Loader />
                        ) : (
                            <div
                                className="ms-4"
                                dangerouslySetInnerHTML={{ __html: RMCopilotData?.Data }}
                            />
                        )}
                    </Modal.Body>
                </Modal>
            }
            {
                showPaceModal &&
                <ProposedRateModal
                    showPaceModal={showPaceModal}
                    setShowPaceModal={setShowPaceModal}
                    data={rateModalDetails}
                />
            }
        </div>
    );
};

export default PriceSimulatorDetailAnalysis;
